class SizeGuide extends HTMLElement {
  constructor() {
    super();
    const form = this.querySelector("form");
    form.addEventListener("change", this.handleChange.bind(this));

    const opener = document.querySelector(".size-guide-modal-opener button");
    opener.addEventListener("click", this.handleOpen.bind(this));

    const closer = document.querySelector(
      ".size-guide-modal__title-bar button"
    );
    closer.addEventListener("click", this.handleClose.bind(this));

    this.container = this.querySelector(".size-guide-modal");

    this.sizeGuideData = {
      XS: {
        US: "0-2",
        bust: '32.5"',
        waist: '25.5"',
        hip: '35.5"',
      },
      S: {
        US: "4-6",
        bust: '34"',
        waist: '27"',
        hip: '37"',
      },
      M: {
        US: "8-10",
        bust: '36"',
        waist: '29"',
        hip: '39"',
      },
      L: {
        US: "12-14",
        bust: '38"',
        waist: '31"',
        hip: '41"',
      },
      XL: {
        US: "14-16",
        bust: '40"',
        waist: '33"',
        hip: '43"',
      },
      "1X": {
        US: "16-18",
        bust: '44"',
        waist: '37"',
        hip: '47"',
      },
      "2X": {
        US: "18-20",
        bust: '46"',
        waist: '39"',
        hip: '49"',
      },
      "3X": {
        US: "20-22",
        bust: '48"',
        waist: '41"',
        hip: '51"',
      },
    };
  }

  handleOpen() {
    this.container.classList.add("size-guide-modal--active");
  }

  handleClose() {
    this.container.classList.remove("size-guide-modal--active");
  }

  handleChange(evt) {
    const size = evt.target.value;
    const sizeInfo = this.sizeGuideData[size];
    this.querySelector(
      ".size-headline"
    ).textContent = `${size} (${sizeInfo.US})`;
    this.querySelectorAll(".bust").forEach((item) => {
      item.textContent = sizeInfo.bust;
    });
    this.querySelectorAll(".waist").forEach((item) => {
      item.textContent = sizeInfo.waist;
    });
    this.querySelectorAll(".hip").forEach((item) => {
      item.textContent = sizeInfo.hip;
    });
  }
}

customElements.define("size-guide", SizeGuide);
